import { useCallback } from 'react';
import { useAmplifyConfig } from './useAmplifyConfig';
import { useStateStorage } from '../contexts/StateStorageContextProvider';
import { useNonceGenerator } from '../contexts/NonceGeneratorContextProvider';
import { startAuthFlow } from '../services/auth';
import { AppConfig } from '../types/app';
import { IdProvider } from '../types/auth';
import { useBreakpoint } from './useBreakpoint';

// Common context, methods, and setup steps used by sign in pages
export function useSignInPageSetup(config: AppConfig) {
  const stateStorage = useStateStorage();
  const nonceGenerator = useNonceGenerator();
  const isMobile = useBreakpoint();

  const enableCookieComponent = Boolean(
    config?.enableCookieComponent === 'true'
  );

  const handleRedirectToIdp = useCallback(
    (provider: IdProvider) => {
      startAuthFlow({
        provider,
        config,
        storage: stateStorage,
        nonceGenerator,
      });
    },
    [config, stateStorage, nonceGenerator]
  );

  useAmplifyConfig(config);

  return {
    enableCookieComponent,
    handleRedirectToIdp,
    isMobile,
  };
}
